import type { SourceLocation } from './api';
import { fmtWhen } from './ui';

/** Where a Google Sheets snapshot came from, as recorded when it was captured.
 * A manual download keeps the link to the sheet it was downloaded from. */
export default function SourceLocationNote({ location }: { location: SourceLocation | null | undefined }) {
  if (!location) return null;
  return (
    <div className="li-source-loc">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></svg>
      <span>
        Snapshot of{' '}
        {location.web_view_link ? <a href={location.web_view_link} target="_blank" rel="noreferrer">{location.name}</a> : <b>{location.name}</b>}
        {location.owner ? ` (${location.owner})` : ''} from Google Drive,{' '}
        {location.capture_method === 'manual_download' ? 'downloaded by hand and uploaded' : 'captured'} {fmtWhen(location.captured_at)}
        {location.modified_time ? `; sheet last modified ${fmtWhen(location.modified_time)}` : ''}
        {location.version ? `, version ${location.version}` : ''}.
      </span>
    </div>
  );
}
